/*
 * @Author: wangxiaoheng
 * @Date: 2023-08-03 15:05:09
 * @LastEditors: wangxiaoheng
 * @LastEditTime: 2023-08-03 15:21:25
 * @FilePath: \megagame_web\src\utils\api\activityContribute.js
 * @Description: 
 * 
 * 
 */
import { post } from "@/utils/https";
const api = "/xywapi";
export async function getcontribute(param) {
  return await post(`${api}/activityContribute/contribute`, param);
}
export async function getcontributeShow(param) {
  return await post(`${api}/activityContribute/show`, param);
}
export async function getpreSignedUrl(param) {
  return await post(`${api}/oss/preSignedUrl`, param);
}